/**
 * Loads Leaflet and all necessary styles.
 */

import React from "react"
import { TileLayer, Map as Leaflet, Marker } from "react-leaflet"

import * as consts from "../constants"

import "leaflet/dist/leaflet.css"
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css" // Re-uses images from ~leaflet package
import "leaflet-defaulticon-compatibility"

// const tileServer = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
export const TILE_SERVER = "https://maps.tramino.net/osm/{z}/{x}/{y}.png"

export function DefaultTileLayer({ dark }) {
	return (
		<TileLayer
			url={TILE_SERVER}
			attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
			className={dark ? "TileLayerDark" : "TileLayer"}
			edgeBufferTiles={1}
		/>
	)
}

export function StaticMap({
	width,
	height,
	center,
	zoom,
	children,
	showMarker,
}) {
	return (
		<div className="StaticMap" style={{ width, height }}>
			<Leaflet center={center} zoom={zoom || consts.ZOOM_INIT}>
				<DefaultTileLayer />
				{showMarker ? <Marker position={center} /> : null}
				{children}
			</Leaflet>
		</div>
	)
}
